import { render } from "./ServiceItsCommunityJoinComp.vue?vue&type=template&id=7d94b229&scoped=true"
import script from "./ServiceItsCommunityJoinComp.vue?vue&type=script&lang=js"
export * from "./ServiceItsCommunityJoinComp.vue?vue&type=script&lang=js"

import "./ServiceItsCommunityJoinComp.vue?vue&type=style&index=0&id=7d94b229&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d94b229"]])

export default __exports__